"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPerson = exports.getPersonId = exports.profileHasPerson = exports.currentProfileUuid = exports.profileLoaded = exports.getCurrentProfile = exports.profile = void 0;
const profile = (state) => state.profile;
exports.profile = profile;
const getCurrentProfile = (state) => (0, exports.profile)(state).currentProfile;
exports.getCurrentProfile = getCurrentProfile;
const profileLoaded = (state) => (0, exports.profile)(state).profileLoaded;
exports.profileLoaded = profileLoaded;
const currentProfileUuid = (state) => (0, exports.getCurrentProfile)(state).uuid;
exports.currentProfileUuid = currentProfileUuid;
const profileHasPerson = (state) => (0, exports.profile)(state).profileHasPerson;
exports.profileHasPerson = profileHasPerson;
const getPersonId = (state) => (0, exports.getCurrentProfile)(state).id;
exports.getPersonId = getPersonId;
const hasPerson = (profile) => profile && profile.uuid && profile.uuid !== '';
exports.hasPerson = hasPerson;
